export default __webpack_public_path__ + "static/media/mrtq_page.f1f5d9fa.png";